<template>
  <v-container fluid>
    <v-row>
      <v-col cols="auto" class="d-flex align-center">
        <v-select
            label="토큰"
            density="comfortable" variant="plain" hide-details
            item-title="owner"
            item-value="token"
            :items="tokens"
            v-model="selectedToken"
        ></v-select>
        <v-btn class="ml-2" icon="mdi-microsoft-excel" variant="text" @click="downloadExcel"></v-btn>
        <v-radio-group
            class="ml-2"
            inline density="comfortable" variant="plain" hide-details
            v-model="isOnline">
          <v-radio label="온라인" :value="true"></v-radio>
          <v-radio label="오프라인" :value="false"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col v-if="0 < appStore.links.length">
        <v-list class="d-flex flex-row-reverse flex-wrap">
          <v-list-item v-for="link in appStore.links">
            <a class="link-item" :href="link.href">{{ link.subject }}</a>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12">
        <v-text-field
            v-model="content.searchWord"
            density="compact" prepend-inner-icon="mdi-magnify"
            hide-details clearable
            @click:clear="content.searchWord = ''"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-pagination v-model="pageIndex.index" density="comfortable" :length="pageIndex.pageLength"></v-pagination>
      </v-col>
      <v-col cols="12" sm="6" md="4" xl="3" v-for="item in pageItems">
        <v-device
            :value="item"
            @on-location-post="onLocationPost(item)"
            @on-posts="onPosts(item)"
            @on-post="post => onPost(item, post)"
            @on-add-post="onAddPost(item)"
            @on-button="params => onButton(item.id, params)"
        ></v-device>
      </v-col>
      <v-row></v-row>
    </v-row>
    <template v-if="isOnline">
      <div class="pending-task-dimm" v-if="taskCardsOpened" @click="taskCardsOpened = false"></div>
      <v-icon
          class="floating-btn"
          :color="newTaskReceived ? 'amber' : 'amber-darken-4'"
          @click="taskCardsOpened = !taskCardsOpened">
        {{ newTaskReceived ? 'mdi-message-badge' : 'mdi-message' }}
      </v-icon>
      <v-card
          :class="['pending-task-content', 'd-flex', 'flex-column', 'elevation-15', taskCardsOpened && 'expanded']"
          color="grey-lighten-2"
      >
        <div class="pending-task-content-item h-100 flex-1-1">
          <v-card-item>
            <div class="ma-n2">
              <v-sheet
                  :class="[
                      'ma-3 pa-4 elevation-2 rounded',
                      task.delay && 'delayed',
                      task.data && (task.data.finishedAt || task.data.canceledAt || task.data.closedAt) && 'complete'
                  ]"
                  style="position: relative;"
                  v-for="task in filteredTasks">
                <div class="text-subtitle-1 text-grey-darken-4 font-weight-black">
                  {{ [task.device.name, task.button.name].join(' ') }}
                </div>
                <div class="text-body-2 text-grey" v-for="description in task.descriptions">
                  {{ description }}
                </div>
                <v-btn
                      icon="mdi-close" density="compact" variant="flat"
                    style="position: absolute;right: 8px;top: 8px;"
                    @click="() => onTaskClose(task)"
                    v-if="task.cancelable"
                ></v-btn>
              </v-sheet>
            </div>
          </v-card-item>
        </div>
        <v-text-field
            v-model="content.taskSearchWord"
            density="compact" hide-details placeholder="검색어를 입력하세요."
            :prepend-inner-icon="clearCompleteTasks ? 'mdi-package-variant-closed-check' : 'mdi-package-variant-closed'"
            @click:prepend-inner="clearCompleteTasks = !clearCompleteTasks"
        ></v-text-field>
      </v-card>
    </template>
    <v-post-dialog
        :model-value="dialog.post"
        @on-delete="dialog.post.onDelete"
        @on-cancel="dialog.post.onCancel"
        @on-ok="dialog.post.onOk"
        @on-confirm="dialog.post.onConfirm"
        v-if="dialog.post.isOpened"
    ></v-post-dialog>
    <v-delayed-popup></v-delayed-popup>
  </v-container>
</template>

<script setup>
import {computed, inject, reactive, ref, watch} from 'vue';
import {useRouter} from 'vue-router';
import {useAppStore} from "@/stores/app";
import {useSessionStore} from "@/stores/session";
import VDevice from "@/components/VDevice.vue";
import debugModule from 'debug';
import {wrapDebug} from "@/common/utils";
import dayjs from "dayjs";
import VPostDialog from "@/components/VPostDialog.vue";
import VDelayedPopup from "@/components/VDelayedPopup.vue";
import * as ExcelJS from "exceljs";

const debug = wrapDebug(debugModule('device'));

const ITEM_LENGTH_PER_PAGE = 24;

const axios = inject('axios');
const network = inject('network');
const router = useRouter();
const appStore = useAppStore();
const sessionStore = useSessionStore();

const responseChain = {
  sessionExpired: async (response, next) => {
    if (response && response.data && 1000 === response.data.code) {
      sessionStore.authorized = false;
      await router.push({name: 'Login'});
      return;
    }
    next && next();
  }
};

const taskCardsOpened = ref(false);
const newTaskReceived = ref(false);
const clearCompleteTasks = ref(false);

const isOnline = ref(true);

const allToken = {owner: '전체', token: null};
const selectedToken = ref(allToken.token);
const tokens = computed(() => appStore.devices
    .reduce((acc, cur) => {
      if (cur.Token && acc.every(({token}) => token !== cur.Token.token))
        acc.push(cur.Token);
      return acc;
    }, [allToken])
    .sort((l, r) => {
      if (l.owner === allToken.owner) return -1;
      if (r.owner === allToken.owner) return 1;
      return l.owner.localeCompare(r.owner)
    })
);

const content = reactive({
  searchWord: '',
  taskSearchWord: '',
  loadDeviceInterval: null,
  loadRemoconInterval: null,
  loadTaskInterval: null,
});

const dialog = reactive({
  post: {
    isOpened: false,
  },
});

const runningDeviceIds = ref([]);

const remoconMapper = computed(() => appStore.remocons.reduce((acc, cur) => ({
  ...acc,
  [cur.name]: cur,
}), {}));

const postMapper = computed(() => appStore.posts.reduce((acc, cur) => ({
  ...acc,
  ...cur.device && cur.device.id && {
    [cur.device.id]: [...acc[cur.device.id] || [], cur],
  }
}), {}));

const [path] = window.location.pathname.replace(/\/+$/, '').split('/').reverse();
const onlineFilter = path === 'online' ? true : path === 'offline' ? false : null;

const filteredItems = computed(() => appStore.devices
    .filter(({name, online, Token}) => {
      if (!Token) return false;
      else if (selectedToken.value && selectedToken.value !== Token.token)
        return false;

      if (isOnline.value !== online)
        return false;

      const searchWord = content.searchWord.trim().toUpperCase();
      if (!searchWord) return true;

      const uppercase = name && name.trim().toUpperCase();
      return uppercase.includes(searchWord);
    })
    .map(device => {
      const remocon = remoconMapper.value[device.deviceType];
      const postForDevice = postMapper.value[device.id];
      return reactive({
        ...device,
        locationPost: postForDevice && postForDevice.find(({type}) => type === 'pinned'),
        locationPostEditable: sessionStore.profile.admin,
        postWritable: sessionStore.profile.admin,
        posts: postForDevice && postForDevice.filter(({type}) => type !== 'pinned') || [],
        descriptions: [
          device.online
              ? `온라인 시간: ${dayjs(device.onlineAt).format('YYYY-MM-DD HH:mm:ss')}`
              : `오프라인 시간: ${dayjs(device.offlineAt).format('YYYY-MM-DD HH:mm:ss')}`,
            device.User && device.User.name || '등록된 가맹점 없음', [
            device.deviceType,
            device.temperature && `${device.temperature}도`,
            device.mode,
            device.fanSpeed ? `팬${device.fanSpeed}` : '',
          ].filter(v => v).join(', ')
        ],
        buttons: remocon && remocon.buttons || [],
        loading: runningDeviceIds.value.includes(device.id),
      });
    })
);

const pageIndex = reactive({
  index: 1,
  pageLength: Math.ceil(filteredItems.value.length / ITEM_LENGTH_PER_PAGE)
});

const pageItems = computed(() => {
  const startIndex = (pageIndex.index - 1) * ITEM_LENGTH_PER_PAGE;
  if (filteredItems.value.length <= startIndex) return [];
  return filteredItems.value.slice(startIndex, startIndex + ITEM_LENGTH_PER_PAGE);
});

const filteredTasks = computed(() => appStore.tasks
    .filter(({data, device, button}) => {
      if (clearCompleteTasks.value && (data.finishedAt || data.canceledAt || data.closedAt))
        return false;

      const taskSearchWord = content.taskSearchWord.trim().toUpperCase();
      if (!taskSearchWord) return true;

      const deviceName = device.name && device.name.trim().toUpperCase();
      const buttonName = button.name && button.name.trim().toUpperCase();
      return deviceName.includes(taskSearchWord) || buttonName.includes(taskSearchWord);
    })
    .map(task => ({
      ...task,
      descriptions: [
        task.data.createdAt ? `등록: ${dayjs(task.data.createdAt).format('MM-DD HH:mm:ss')}` : null,
        task.data.wakeupAt ? `예약: ${dayjs(task.data.wakeupAt).format('MM-DD HH:mm:ss')}` : null,
        task.data.startedAt ? `시작: ${dayjs(task.data.startedAt).format('MM-DD HH:mm:ss')}` : null,
        task.data.finishedAt ? `종료: ${dayjs(task.data.finishedAt).format('MM-DD HH:mm:ss')}` : null,
        task.data.canceledAt ? `취소: ${dayjs(task.data.canceledAt).format('MM-DD HH:mm:ss')}` : null,
      ].filter(v => v),
      cancelable: task.data.finishedAt === null &&
          task.data.closedAt === null &&
          task.data.canceledAt === null,
    }))
);

watch(filteredItems, newValue => {
  const pageLength = Math.max(1, Math.ceil(newValue.length / ITEM_LENGTH_PER_PAGE));
  pageIndex.index = Math.min(pageIndex.index, pageLength);
  pageIndex.pageLength = pageLength;
});

watch(taskCardsOpened, (newValue, oldValue) => {
  if (!newValue || oldValue) return;
  newTaskReceived.value = false;
  appStore.loadTasks();
});

const downloadExcel = () => {
  const workbook = new ExcelJS.Workbook();

  const token = tokens.value.find(({token}) => token === selectedToken.value);

  // sheet 생성
  const sheetName = token.owner;
  const worksheet = workbook.addWorksheet(sheetName);
  // worksheet.columns = columns.map(column => ({
  //   header: column, key: column,
  // }));
  worksheet.columns = [
    { header: 'id', key: 'id', width: 140 / 6},
    { header: 'name', key: 'name', width: 200 / 6},
    { header: 'owner', key: 'owner', width: 80 / 6},
    { header: 'token', key: 'token', width: 220 / 6},
    { header: 'deviceType', key: 'deviceType', width: 120 / 6},
    { header: 'online', key: 'online', width: 40 / 6},
    // { header: 'onlineAt', key: 'onlineAt', width: 140 / 6},
    // { header: 'offlineAt', key: 'offlineAt', width: 140 / 6},
  ];
  const data = filteredItems.value.map(device => ({
    id: device.id,
    name: device.name,
    owner: device.Token && device.Token.owner,
    token: device.Token && device.Token.token,
    deviceType: device.deviceType,
    online: device.online ? 'online' : 'offline',
    onlineAt: device.onlineAt && dayjs(device.onlineAt).format('YYYY-MM-DD HH:mm:ss.SSS'),
    offlineAt: device.offlineAt && dayjs(device.offlineAt).format('YYYY-MM-DD HH:mm:ss.SSS'),
  }));
  worksheet.insertRows(2, data);

  (async () => {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = '장치목록.xlsx';
    anchor.click();
    window.URL.revokeObjectURL(url);
  })();
};

const onLocationPost = device => {
  (async () => {
    const post = device.locationPost || {
      editable: true,
      subject: '',
      content: '',
      attachments: [],
    };

    const renew = await new Promise(r => dialog.post = {
      isOpened: true,
      canEdit: sessionStore.profile.admin,
      pinned: true,
      device,
      editable: false,
      ...post,
      onDelete:  () => r(true),
      onCancel: () => r(false),
      onOk: () => r(true),
      onConfirm: () => r(false),
    });
    dialog.post.isOpened = false;

    if (renew) appStore.loadPosts().then();
  })();
};

const onPosts = device => {

};

const onPost = (device, post) => {
  (async () => {
    const renew = await new Promise(r => dialog.post = {
      isOpened: true,
      canEdit: sessionStore.profile.admin,
      pinned: false,
      device,
      editable: false,
      ...post,
      onDelete:  () => r(true),
      onCancel: () => r(false),
      onOk: () => r(true),
      onConfirm: () => r(false),
    });
    dialog.post.isOpened = false;

    if (renew) appStore.loadPosts().then();
  })();
};

const onAddPost = device => {
  (async () => {
    const renew = await new Promise(r => dialog.post = {
      isOpened: true,
      canEdit: true,
      pinned: false,
      device,
      editable: true,
      subject: '',
      content: '',
      attachments: [],
      onDelete:  () => r(true),
      onCancel: () => r(false),
      onOk: () => r(true),
      onConfirm: () => r(false),
    });
    dialog.post.isOpened = false;

    if (renew) appStore.loadPosts().then();
  })();
};

const onButton = (deviceId, params) => {
  const {delay, hours, minutes, buttonId} = params;

  const device = filteredItems.value.find(({id}) => id === deviceId);
  if (!device) return;
  const button = device.buttons.find(({id}) => id === buttonId);
  if (!button) return;

  const remocon = remoconMapper.value[device.deviceType];
  if (!remocon) return;

  (async () => {
    runningDeviceIds.value = [...runningDeviceIds.value.filter(id => id !== deviceId), deviceId];
    await (async () => {
      try {
        const response = await axios.post(`/api/task`, {
          delay, hours, minutes,
          device, button, commands: remocon.commands,
        });
        if (response.data && response.data.code === 1004) {
          alert('해당 리모콘에 등록된 작업이 있습니다.');
          return;
        }

        await appStore.loadTasks();
        newTaskReceived.value = true;

      } catch (error) {
        console.log(error);
      }
    })();
    runningDeviceIds.value = runningDeviceIds.value.filter(id => id !== deviceId);
  })();
};

const onTaskClose = task => {
  const operation = confirm(`${task.device.name} ${task.button.name}을(를) 취소하시겠습니까?`);
  if (!operation) return;

  (async () => {
    try {
      await axios.delete(`/api/task/${task.id}`);
      await appStore.loadTasks();

    } catch (error) {
      console.log(error);
    }
  })();
};

</script>

<style scoped>

a.link-item {
  color: #e91e63;
  text-decoration: none;
}
a.link-item:hover {
  text-decoration: underline;
}
.floating-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 2rem;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

/*
.pending-task-wrapper {
  position: fixed;
  bottom: 0;
  right: 1rem;
  width: calc(100% - 56px - 1rem);
  max-width: 500px;
  height: 0;
  padding: 154px 2rem 100px;
}

.pending-task-wrapper.expanded {
  height: 100%;
}

.pending-task-content {
  width: 100%;
  height: 100%;
}
*/

.pending-task-content {
  position: fixed;
  bottom: 6rem;
  right: 2.5rem;
  max-width: 400px;
  width: calc(100% - 56px - 2.5rem);
  height: 0;
  overflow: hidden;
  transition: height 0.2s;
}

.pending-task-content.expanded {
  min-height: 200px;
  height: calc(100% - 15rem - 6rem);
}

.pending-task-content-item {
  overflow-y: auto;
}

.pending-task-content-item .complete {
  opacity: .5;
}

.pending-task-content-item .delayed:not(.complete) {
  background: #FDD835;
}

.pending-task-content-item .delayed:not(.complete) > button {
  background: #FDD835;
}

.pending-task-dimm {
  position: absolute;;
  background: #000;
  inset: 0;
  opacity: .5;
}

/*
.pending-task-content-item {
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
*/
/*
.pending-task-content-item::-webkit-scrollbar {
  width: 0;
  height: 0;
}
*/
</style>
